/**
 * Pure routing decision for the index/dashboard landing, extracted so it can
 * be unit-tested without a Redux store + router.
 */
export type DashboardLanding = 'parent' | 'no-membership' | 'dashboard';

export function resolveDashboardLanding(input: {
  isParent: boolean;
  isSuperAdmin: boolean;
  membershipCount: number;
}): DashboardLanding {
  // Active parent → the /parent (kid-as-frame) tree.
  if (input.isParent) return 'parent';

  // Authenticated but no membership to act under, and not a platform admin.
  // Almost always a parent whose membership is still dormant (invite-signup
  // not completed). Show the onboarding-pending state instead of dumping them
  // on the staff Dashboard, whose API calls would 403.
  if (!input.isSuperAdmin && input.membershipCount === 0) return 'no-membership';

  // Staff / admin / super-admin → the normal Dashboard.
  return 'dashboard';
}
